export enum BankAccountVerifyStatus {
  PENDING_AUTOMATIC_VERIFICATION = "pending_automatic_verification",
  PENDING_MANUAL_VERIFICATION = "pending_manual_verification",
  AUTOMATICALLY_VERIFIED = "automatically_verified",
  MANUALLY_VERIFIED = "manually_verified",
  VERIFICATION_EXPIRED = "verification_expired",
  VERIFICATION_FAILED = "verification_failed",
  INSTANTLY_VERIFIED = "instantly_verified",
}
